<!-- background : position[bottom[flex-end]/top[flex-top]/center[center]] -->
<div class="inbox-wrapper" [style]="inboxposition">
  @if (!hideCloseButton) {
    <ion-fab slot="fixed" vertical="top" horizontal="end">
      <ion-fab-button (click)="closeDialog()">
        <img src="assets/images/cross-img.png" alt="Close Dialog" />
      </ion-fab-button>
    </ion-fab>
  }
  <!-- background : background-image/bg-color/padding/height -->
  <div class="inner-wrapper" [style]="backgroundStyle">
    <!-- hero : img-url/height/text-position -->
    @if (heroData) {
      <div class="img-banner" [style]="heroImageStyle">
        <div class="floting-text" style="width: 100%; text-align: center;">
          @for (item of heroText; track item) {
            <p [style.color]="item.color" [innerHTML]="item.content">
            </p>
          }
        </div>
      </div>
    }
    @if (bodyData) {
      <div class="text-body" [style]="bodyStyle">
        @for (item of bodyText; track item) {
          <p [style.color]="item.color" [innerHTML]="item.content">
          </p>
        }
      </div>
    }
    @if (countDownData) {
      <div class="countdown-text" [ngClass]="{'dt-badge' : checkIfCustomStyleExists()}"
        [style]="countDownStyle">
        @for (item of countDownText; track item) {
          <div [style.color]="item.color" [innerHTML]="item.content">
          </div>
        }
      </div>
    }
    @if (buttonData) {
      <div class="button-wrapperx">
        <!-- Button : label/font-weight/height/width/float  -->
        <button class="play_btn" [style]="buttonStyle" (click)="openUrl()"> {{buttonData?.label ?? "Play" }} </button>
      </div>
    }
  </div>
</div>
